import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ImagePlus, Loader2, Trash2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// PDF başlık bandında görünen AVM logosu (Süper Admin)
export const PdfLogoCard = () => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const load = () => axios.get(`${API}/settings/pdf-logo`, { responseType: 'blob' })
    .then(res => setUrl(URL.createObjectURL(res.data))).catch(() => setUrl(null));
  useEffect(() => { load(); }, []);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      await axios.put(`${API}/settings/pdf-logo`, fd);
      toast.success('Logo kaydedildi; yeni PDF raporlarında başlık bandında görünecek');
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Logo yüklenemedi');
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const remove = async () => {
    setBusy(true);
    try { await axios.delete(`${API}/settings/pdf-logo`); setUrl(null); toast.success('Logo kaldırıldı'); } catch { toast.error('Logo kaldırılamadı'); } finally { setBusy(false); }
  };

  return (
    <Card data-testid="pdf-logo-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg"><ImagePlus className="h-5 w-5 text-blue-700" />PDF Logosu</CardTitle>
        <CardDescription>Eksiklik raporu ve onay PDF'lerinin başlık bandında sol üstte görünür. PNG/JPG/WEBP, en fazla 3 MB; şeffaf arka planlı logo önerilir.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center gap-4">
        <div className="flex h-20 w-56 items-center justify-center rounded-lg px-3" style={{ background: '#0f172a' }} data-testid="pdf-logo-preview">
          {url ? <img src={url} alt="PDF logosu" className="max-h-16 max-w-full object-contain" /> : <span className="text-xs text-slate-400">Logo yüklenmedi</span>}
        </div>
        <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="pdf-logo-input" />
        <Button onClick={() => inputRef.current?.click()} disabled={busy} data-testid="pdf-logo-upload-btn">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <ImagePlus className="mr-2 h-4 w-4" />}{url ? 'Logoyu Değiştir' : 'Logo Yükle'}
        </Button>
        {url && <Button variant="outline" onClick={remove} disabled={busy} className="text-rose-600 hover:bg-rose-50 hover:text-rose-700" data-testid="pdf-logo-remove-btn"><Trash2 className="mr-2 h-4 w-4" />Kaldır</Button>}
      </CardContent>
    </Card>
  );
};
